import React, { Component } from 'react';
import { Trans } from 'react-i18next';

import { closeHtml } from '../../services/externalMethods';
/**
 *  @desc Plans handler component
 *  Displays the plans page
 */
class Error extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Remove the loader class
        window.document.body.classList.remove('loader');
    }

    onClickHandler() {
        closeHtml('dismiss_error');
    }

    render() {
        return (
            <div className="body-spotlight">
                <div className="main-content error-page">
                    <div className="error-image"/>
                    <div className="error-text kievitlight">
                        <Trans i18nKey="spotlight.error_page.general_label" />
                    </div>
                    <div onClick={this.onClickHandler} className="btn btn-secondary">
                        <Trans i18nKey="spotlight.general.buttons.dismiss_error" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Error;
